import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export const RouteLeavingGuard = ({
    navigate,
    when,
    shouldBlockNavigation,
    yes,
    onYes,
    no,
    content,
    header = '',
}) => {
    const [modalVisible, updateModalVisible] = useState(false);
    const [lastLocation, updateLastLocation] = useState();
    const [confirmedNavigation, updateConfirmedNavigation] = useState(false);

    const showModal = (location) => {
        updateModalVisible(true);
        updateLastLocation(location);
    };

    const closeModal = (cb) => {
        updateModalVisible(false);
        if (cb) {
            cb();
        }
    };

    const handleBlockedNavigation = (nextLocation) => {
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            showModal(nextLocation);
            return false;
        }
        return true;
    };

    const handleConfirmNavigationClick = () => {
        closeModal(() => {
            if (lastLocation) {
                updateConfirmedNavigation(true);
            }
        });
    };

    const handleClickYes = () => {
        closeModal(onYes);
    };

    useEffect(() => {
        if (confirmedNavigation) {
            navigate(lastLocation.pathname);
            updateConfirmedNavigation(false);
        }
        //eslint-disable-next-line
    }, [confirmedNavigation]);

    return (
        <div className=''>
            <Prompt when={when} message={handleBlockedNavigation} />
            <Modal  isOpen={modalVisible} toggle={() => closeModal()}>
                <ModalHeader
                    toggle={() => closeModal()}
                    className="bg-primary text-white fw-bold modalCloase"
                    tag="div"
                    close={
                        <button
                            className="btn-close btn-close-white"
                            onClick={() => closeModal()}
                        ></button>
                    }
                >
                    {header}
                </ModalHeader>
                <ModalBody>{content}</ModalBody>
                <ModalFooter className="justify-content-between">
                    <Button
                        color="primary"
                        onClick={() => handleConfirmNavigationClick()}
                    >
                        {no}
                    </Button>

                    {!!yes && (
                        <Button
                            color="primary"
                            onClick={() => handleClickYes()}
                        >
                            {yes}
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default RouteLeavingGuard;